export const BOOTCAMP_PAGE_POSTHOG_VARIANTS = ['control', 'test'] as const;

/** Fresh draft; separate history from the older Clarity paint experiment. */
export const BOOTCAMP_CLARITY_HOME_EXPERIMENT = {
  name: 'ai_trading_bootcamp_control_vs_clarity_home_2026_09_22',
  featureFlag: 'ai-trading-bootcamp-control-vs-clarity-home-2026-09-22',
  posthogExperimentId: 466498,
  status: 'draft',
  variants: ['control', 'test'],
} as const;

export const BOOTCAMP_CLARITY_HOME_CANDIDATE = {
  ...BOOTCAMP_CLARITY_HOME_EXPERIMENT,
  reviewPath: '/courses/ai-trading-bootcamp/clarity-home',
  component: 'CoursePageClarityHome',
  primaryMetric: 'Live Bootcamp checkout conversion',
  secondaryMetrics: ['Live Bootcamp payment conversion', 'Live Bootcamp revenue per exposed user'],
} as const;

export const BOOTCAMP_PAGE_EXPERIMENT = {
  name: 'ai_trading_bootcamp_control_vs_clarity_2026_08_31',
  featureFlag: 'ai-trading-bootcamp-control-vs-clarity-2026-08-31',
  posthogExperimentId: 459167,
  predecessorPosthogExperimentId: 445277,
  status: 'active',
  posthogVariants: BOOTCAMP_PAGE_POSTHOG_VARIANTS,
  variants: {
    control: 'Current bootcamp page',
    test: 'Clarity bootcamp page',
  },
  primaryMetric: 'Live Bootcamp checkout conversion',
  secondaryMetrics: ['Live Bootcamp payment conversion', 'Live Bootcamp revenue per exposed user'],
} as const;
